var m = require('mithril');
var Promise = require('bluebird');
var moment = require('moment-timezone');
var prop = require('mithril/stream');
var pathHeader = require('../layout/components/pathHeader');
var serverSidePagination = require('../data/components/serverSidePagination');
var downloadReportModalInterface = require('../layout/components/downloadReportModalInterface');
var dragscroll = require('../libs/dragscroll');
var loaders = require('../layout/components/loaders');
var buildEventReportDownloadOptions = require('../alarms/buildEventReportDownloadOptions');

var dateFormat = 'MM-DD-YYYY hh:mm:ss a';

var locationEventSummary = {
  oninit : function (vnode) {
    var ctrl = this;
    ctrl.locationRid = m.route.param('id');
    ctrl.location = prop();
    ctrl.eventsRids = prop();
    ctrl.eventsToShow = prop([]);
    ctrl.eventsSortedByStartDate = prop(false);
    ctrl.eventsSortedByEndDate = prop(false);
    ctrl.newNode = prop(false);
    ctrl.searchEventActive = prop(false);
    ctrl.searchEvent = prop('');
    ctrl.eventsToShow = prop([]);
    ctrl.pageNumber = prop(0);
    ctrl.preferredNumberOfRowsValue = prop(30);

    ctrl.init = function (){
      loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/'+ (ctrl.locationRid || ''),
        method: 'GET'
      }).then(result=>{
        ctrl.location(result);
        ctrl.location().path.reverse();
        ctrl.fakePath = {'@rid': 1, 'name': 'Event Summary'}
        ctrl.location().path.push(ctrl.fakePath)
        return Promise.all([
          loaders.requestWithLoader({
            loader: 'main',
            url: '/api/v1/alarmevents/rids',
            method: 'GET',
            params: {
              locationRid: ctrl.location()['name'] == 'root' ? null : ctrl.location()['@rid'].slice(1)
            }
          }),
          loaders.requestWithLoader({
            loader: 'main',
            url: '/api/v1/alarmevents/paginated',
            method: 'GET',
            params: {
              locationRid: ctrl.location()['name'] == 'root' ? null : ctrl.location()['@rid'].slice(1),
              pageNumber: ctrl.pageNumber(),
              search: ctrl.searchEvent(),
              preferredNumberOfRowsValue: ctrl.preferredNumberOfRowsValue()
            }
          })
        ])
      })
      .then( data => {
        ctrl.eventsRids(data[0]);
        ctrl.eventsToShow(data[1]);
        ctrl.eventsToShow().forEach(eventRecord => {
          eventRecord.ocurredAt = eventRecord.out_OccurredAt && eventRecord.out_OccurredAt[0].in.name ? eventRecord.out_OccurredAt[0].in.name: '';
        });
        ctrl.sortEventByStartTime();
        m.redraw();
      })
    }

    
    ctrl.init();

    ctrl.sortEventByStartTime = function () {
      ctrl.eventsSortedByStartDate(!ctrl.eventsSortedByStartDate());
      if (ctrl.eventsSortedByStartDate()) {
        ctrl.eventsToShow(ctrl.eventsToShow().sort((a,b) => (a.start > b.start)?1:-1));
      } else {
        ctrl.eventsToShow(ctrl.eventsToShow().sort((a,b) => (b.start > a.start)?1:-1));
      }
      m.redraw();
    }
    ctrl.sortEventByEndTime = function () {
      ctrl.eventsSortedByEndDate(!ctrl.eventsSortedByEndDate());
      if (ctrl.eventsSortedByEndDate()) {
        ctrl.eventsToShow(ctrl.eventsToShow().sort((a,b) => (a.end > b.end)?1:-1));
      } else {
        ctrl.eventsToShow(ctrl.eventsToShow().sort((a,b) => (b.end > a.lastAction)?1:-1));
      }
      m.redraw();
    }

  },
  onupdate: function (vnode) {
    var ctrl = this;
  },
  view: function (vnode) {
    var ctrl = this;
    if(!ctrl.location() || !ctrl.eventsRids()){
      return m('div');
    }
    return m('div.mh3', [
      m(pathHeader, {
        ancestors: ctrl.location().path,
        record: ctrl.fakePath,
        class: '.flex.flex-wrap'
      }),
      m('div', [
        m('div.overflow-hidden.mb3', [
          m('div.dragscroll-container', [
            m('div.dragscroll', {oncreate: dragscroll}, [
              m('table.f4.pb3.narrow.w-100', {
                onclick: (e) => {
                  if(e.target !== document.getElementById('alarm-table-search-icon') && e.target !== document.getElementById('alarm-table-search-input') && ctrl.searchEvent().length == 0){
                    ctrl.searchEventActive(false);
                  }
                }
              }, [
                m('tbody', [
                  m('tr', [
                    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', {
                    },[
                      m('div', {style: {display: (ctrl.searchEventActive() ? 'none' : 'block')}}, [
                        'Location',
                        m('i', {
                          id: 'alarm-table-search-icon',
                          class: 'blue f2 mh2 ion-search pointer',
                          onclick: (e) => {
                            ctrl.searchEventActive(true)
                            setTimeout(function(){ document.getElementById('alarm-table-search-input').focus(); }, 1);
                          },
                        })
                      ]),
                      m('div.flex.items-center', {style: {display: (ctrl.searchEventActive() ? 'flex' : 'none')}}, [
                        'Location',
                        m('input.ml3.w4', {
                          id: 'alarm-table-search-input',
                          placeholder: 'Search',
                          value: ctrl.searchEvent(),
                          oninput: function (ev) { 
                            ctrl.searchEvent(ev.target.value);
                          },
                          onblur: (e) => {
                            if (ctrl.searchEvent().length == 0) {
                              ctrl.searchEventActive(false);
                            }
                          }
                        })
                      ])
                    ]),
                    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', {
                    },[
                      m('div', { onclick: ctrl.sortEventByStartTime }, [
                        'Start Time',
                        ctrl.eventsSortedByStartDate() ? m('i.ion-ios-arrow-down.ml2.pointer.blue') : m('i.ion-ios-arrow-up.ml2.pointer.blue')
                      ])
                    ]),
                    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', {
                    },[
                      m('div', { onclick: ctrl.sortEventByEndTime }, [
                        'End Time',
                        ctrl.eventsSortedByEndDate() ? m('i.ion-ios-arrow-down.ml2.pointer.blue') : m('i.ion-ios-arrow-up.ml2.pointer.blue')
                      ])
                    ]),
                    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Event Type'),
                    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Report Link'),
                  ]),
                  ctrl.eventsToShow().map(eventRecord => {
                    return m('tr', [
                      m('td.pr2.bb.bl-0.truncate', [
                        (()=>{
                          if(eventRecord.out_OccurredAt && eventRecord.out_OccurredAt[0].in.name){
                            return m(m.route.Link, {href: `/location/${eventRecord.out_OccurredAt[0].in['@rid'].slice(1)}`}, [
                              eventRecord.out_OccurredAt[0].in.name
                            ])
                          }else{
                            return m('label',{style:{'visibility':'hidden'}}, 'No Data')
                          }
                        })()
                      ]),
                      m('td.pr2.bb.bl-0.truncate', eventRecord.start ? moment(eventRecord.start).format(dateFormat) : ''),
                      m('td.pr2.bb.bl-0.truncate', eventRecord.end ? moment(eventRecord.end).format(dateFormat) : ''),
                      m('td.pr2.bb.bl-0', eventRecord.eventType ? eventRecord.eventType : ''),
                      m('td.pr2.bb.bl-0', [
                        (()=>{
                          if(eventRecord.out_OccurredAt && eventRecord.out_OccurredAt[0].in['@rid']){
                            return m('div.flex',[
                              m('span.ba.b--red.red.ph1.br2.white.tc.dim.pointer.f5.mr2', {
                                onclick: (e) => downloadReport(eventRecord, 'pdf', ctrl.location())
                              },[
                                'PDF'
                              ]),
                              m('span.ba.b--green.green.ph1.br2.white.tc.dim.pointer.f5', {
                                onclick: (e) => downloadReport(eventRecord, 'xlsx', ctrl.location())
                              },[
                                'Excel'
                              ]),
                            ])
                          }
                        })()
                      ])
                    ])
                  }),
                ])
              ])
            ])
          ])
        ]),
        (()=>{
          if(ctrl.eventsRids().length > 0){
            return m(serverSidePagination, {
              data: [...ctrl.eventsRids()],
              url: '/api/v1/alarmevents/paginated',
              recordsToShow: ctrl.eventsToShow,
              parameterFieldName: 'pageNumber',
              searchValue: ctrl.searchEvent,
              preferredNumberOfRowsValue: ctrl.preferredNumberOfRowsValue,
              locationRid: ctrl.location()['name'] == 'root' ? null : ctrl.location()['@rid'].slice(1),
            })
          }
        })()
      ])
    ]);
  }
};

function downloadReport(eventRecord, format, contextLocation){
  var options = buildEventReportDownloadOptions(eventRecord, contextLocation);
  options.format = format;
  downloadReportModalInterface.editDialogue(options);
}

module.exports = locationEventSummary;
